import styled, { css } from "styled-components";
import { theme as lexusTheme } from "../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import * as Type from "../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import { lineClampStyle } from "../../../../../../common-deprecated/styles/v2/lexus/utilities/Lineclamp";
import { getBreakpoint } from "../../../../../../common-deprecated/themes/common";
import * as Button from "../../../../../../common-deprecated/styles/v2/lexus/components/Button";

export const Title = styled(Type.H3)`
    font-family: ${lexusTheme.fonts.regular};
    font-size: 2rem;
    line-height: 2.8rem;
    ${lineClampStyle};

    @media ${getBreakpoint("up", "lg")} {
        font-size: 2.8rem;
        line-height: 3rem;
    }
`;

export const CustomizeButton = styled.a`
    font-size: 1.3rem;
    color: ${lexusTheme.colors.grey7};
    span {
        position: relative;
        top: 1px;
        margin-right: 4px;
    }

    html[dir="rtl"] & {
        span {
            margin-left: 4px;
            margin-right: 0;
        }
    }
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;

    /* Fix wrong alignment button in ContentWrapper when the RTL layout is active */
    ${Button.ButtonSecondary} {
        ${({ theme }) =>
            theme.isRTL &&
            css`
                margin-right: 0 !important;
            `};
    }
`;

export const Description = styled.p`
    margin-bottom: ${lexusTheme.space[3]}px;
    color: ${lexusTheme.colors.grey3};
`;
